
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { useAuthStore } from './store/authStore';
import { useSettingsStore } from './store/settingsStore';
import { useEffect, useState } from 'react';
import LoadingScreen from './components/LoadingScreen';
import { initWorker, terminateWorker } from './workers/workerService';
import { useRoutes } from 'react-router-dom';
import routes from './routes';
import { Suspense } from 'react';
import { useAppContext } from './context/AppContext';
import packageJson from '../package.json';

function App() {
  const routing = useRoutes(routes);
  //const page: string = window.location.pathname.split('/').filter(part => part !== '')[0];
  const checkAuth = useAuthStore(state => state.checkAuth)
  const {isOnline} = useAppContext();
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    const initApp = async () => {
      console.log("Seen AI story v" + packageJson.version);
      
      await useSettingsStore.getState().loadSettings(); // дождаться настроек
  
      if (import.meta.env.MODE !== 'production') {
        console.log("Mode: ", import.meta.env.MODE);
      }
  
      if (isOnline) {
        await checkAuth();
      } else {
        console.log("Offline mode");
      }
  
      setIsInitialized(true);
      initWorker();
    };
  
    initApp();
  
    return () => {
      terminateWorker();
    };
  }, []);

  if (!isInitialized) return <LoadingScreen />

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/*page === 'oauth'
        ? <OauthCallback />
        : <Video />
      */}
      {routing}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        draggable
        pauseOnHover
        theme={"light"}
      />
      {import.meta.env.MODE !== 'production' &&
        <div className="fixed top-0 right-[40%] p-2 text-xs text-gray-100 bg-red-700 rounded-b">
          {import.meta.env.MODE}
        </div>
      }
    </Suspense>
  );
}

export default App;
